import RollDice from './RollDice'
import './App.css'

function App() {
  return (
    <div className='App'>
      <RollDice />
    </div>
  )
}

export default App